import { CustomFabricImage } from '../../../global-types';
import { deletePhoto } from './delete-photo';

type DeleteCardFacePhotoParams = {
  currentPhoto: fabric.Image & { data?: CustomFabricImage };
  canvas: fabric.Canvas;
  projectId: string;
  deleteImage: (projectId: string, imageName: string) => Promise<any>;
  addAction: (actionType: string, payload: any) => void;
  appDispatch: React.Dispatch<any>;
  errorTitle: string;
  errorMessage: string;
};

/**
 * Deletes a photo from the card face.
 * This function removes a photo from the card face and updates the canvas accordingly.
 * @param {DeleteCardFacePhotoParams} params - The parameters for deleting a card face photo.
 * @returns A promise that resolves when the photo is deleted.
 */
export async function deleteCardFacePhoto({
  currentPhoto,
  canvas,
  projectId,
  deleteImage,
  addAction,
  appDispatch,
  errorTitle,
  errorMessage,
}: DeleteCardFacePhotoParams) {
  await deletePhoto({
    currentPhoto,
    canvas,
    projectId,
    deleteImage,
    addAction,
    appDispatch,
    errorTitle,
    errorMessage,
    removeActionType: 'remove-photo-from-card-face',
  });
}
